// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;Before the mountains were brought forth,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;or the earth and the world were formed,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;from everlasting to everlasting you are God.<br> </p> </div></div>";
// Exports
module.exports = code;